import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-6d298fc3.js';
import React, { useState, useEffect } from 'react';

require("es6-promise").polyfill();

var WeducNewsFeed = function WeducNewsFeed(props) {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      newsFeedData = _useState2[0],
      setNewsFeedData = _useState2[1];

  var _useState3 = useState(props.limit),
      _useState4 = _slicedToArray(_useState3, 2),
      count = _useState4[0],
      setCount = _useState4[1];

  useEffect(function () {
    var getApiData = function getApiData() {
      var weducAPIURL = props.weducAPIURL ? props.weducAPIURL : "https://weduc.accropress.com/smartfeed/";
      fetch(weducAPIURL + "getnewsfeeddata/" + props.name + "/" + props.container).then(function (response) {
        return response.json();
      }).then(function (jsonList) {
        if (jsonList && jsonList.data && jsonList.data.river && jsonList.data.river.length > 0) {
          if (props.limit && jsonList.data && jsonList.data.river) {
            if (!props.pagination) {
              jsonList.data.river = jsonList.data.river.splice(0, props.limit);
            }

            setNewsFeedData(jsonList);
          } else {
            setNewsFeedData(jsonList);
          }

          props.loadedEvent(true);
        }
      });
    };

    getApiData();
  }, []);
  var Html = props.html;

  var updatePagination = function updatePagination() {
    setCount(count + props.limit);
  };

  if (props.pagination) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, newsFeedData.data && newsFeedData.data.river ? newsFeedData.data.river.slice(0, count).map(function (news, i) {
      return /*#__PURE__*/React.createElement(Html, {
        key: i,
        data: news,
        route: props.route
      });
    }) : /*#__PURE__*/React.createElement("div", {
      className: "no-results"
    }, "There are no news items to display."), props.pagination && newsFeedData && newsFeedData.data && newsFeedData.data.river && newsFeedData.data.river.length > count && /*#__PURE__*/React.createElement("button", {
      className: "btn btn-primary",
      onClick: function onClick() {
        return updatePagination();
      }
    }, "Load more"));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, newsFeedData.data && newsFeedData.data.river ? newsFeedData.data.river.map(function (news, i) {
      return /*#__PURE__*/React.createElement(Html, {
        key: i,
        data: news,
        route: props.route
      });
    }) : /*#__PURE__*/React.createElement("div", {
      className: "no-results"
    }, "There are no news items to display."));
  }
};

export default WeducNewsFeed;